// Using the same API gateway as other services
const API_BASE_URL = 'https://4vkpvv0re3.execute-api.ap-southeast-2.amazonaws.com/v1';

class AssessmentScheduleAPI {
  constructor() {
    this.adminUrl = `${API_BASE_URL}/assessment-schedule-admin`;
    this.publicUrl = `${API_BASE_URL}/assessment-schedule-public`;
  }

  // 获取认证头 (仅用于管理员API)
  getAuthHeaders(idToken) {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };
  }

  // ========== 管理员 API ==========

  // 创建新的排程
  async createSchedule(scheduleData, idToken) {
    try {
      const response = await fetch(this.adminUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'create',
          data: scheduleData
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating schedule:', error);
      throw error;
    }
  }

  // 获取所有排程（管理员用）
  async getAllSchedules(idToken) {
    try {
      const response = await fetch(this.adminUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'read',
          data: {}
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching all schedules:', error);
      throw error;
    }
  }

  // 获取单个排程
  async getSchedule(scheduleId, idToken) {
    try {
      const response = await fetch(this.adminUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'read',
          data: {
            id: scheduleId
          }
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching schedule:', error);
      throw error;
    }
  }

  // 更新排程
  async updateSchedule(scheduleId, updateData, idToken) {
    try {
      const response = await fetch(this.adminUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'update',
          data: {
            id: scheduleId,
            ...updateData
          }
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating schedule:', error);
      throw error;
    }
  }

  // 删除排程
  async deleteSchedule(scheduleId, idToken) {
    try {
      const response = await fetch(this.adminUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'delete',
          data: {
            id: scheduleId
          }
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting schedule:', error);
      throw error;
    }
  }

  // ========== 公共 API ==========

  // 获取激活的排程（公共访问，无需认证）
  async getActiveSchedules() {
    try {
      const response = await fetch(this.publicUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // 缓存到 sessionStorage 以减少API调用
      sessionStorage.setItem('assessmentSchedules', JSON.stringify({
        data: data,
        timestamp: Date.now()
      }));

      return data;
    } catch (error) {
      console.error('Error fetching active schedules:', error);
      
      // 如果API失败，尝试从缓存获取
      const cached = sessionStorage.getItem('assessmentSchedules');
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        const oneHour = 60 * 60 * 1000;
        
        // 如果缓存不超过1小时，使用缓存数据
        if (Date.now() - timestamp < oneHour) {
          console.log('Using cached assessment schedules');
          return data;
        }
      }
      
      throw error;
    }
  }

  // 清除缓存
  clearCache() {
    sessionStorage.removeItem('assessmentSchedules');
  }

  // 获取缓存的排程（如果存在）
  getCachedSchedules() {
    const cached = sessionStorage.getItem('assessmentSchedules');
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      const oneHour = 60 * 60 * 1000;
      
      if (Date.now() - timestamp < oneHour) {
        return data;
      }
    }
    return null;
  }
}

export const assessmentScheduleAPI = new AssessmentScheduleAPI();